import { Fragment, useMemo } from 'react';

import H from '@zola/zola-ui/src/typography/Headings';

import { ModalContainer } from '~/components/common/ModalRoot';

import { SearchButton } from '../../../SearchBar/SearchButton';
import { useSearchResultsPageContext } from '../../contexts/SearchResultsPageContext';
import { useVendorSearchNavigation } from '../../contexts/VendorSearchNavigationContext';
import { useSRPSearchBarContext } from './SRPSearchBarContext';
import { SRPSearchBarDropdowns } from './SRPSearchBarDropdowns';

import styles from './changeSearchModal.module.less';

export const ChangeSearchModal = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
}) => {
  const { selectedLocation, nextTaxonomySearch, clearSelections } = useSRPSearchBarContext();

  const { navigateToSrp } = useVendorSearchNavigation();
  const { vendorSearch } = useSearchResultsPageContext();

  const disableModalSearchButton = useMemo(() => {
    const isTaxonomyTheSame = nextTaxonomySearch?.key === vendorSearch?.selectedTaxonomy?.key;
    const isLocationTheSame = selectedLocation.slug === vendorSearch?.selectedLocation?.slug;

    return isTaxonomyTheSame && isLocationTheSame;
  }, [
    nextTaxonomySearch?.key,
    selectedLocation.slug,
    vendorSearch?.selectedLocation?.slug,
    vendorSearch?.selectedTaxonomy?.key,
  ]);

  if (!isOpen) {
    return <Fragment />;
  }

  return (
    <ModalContainer
      isOpen
      className={styles.modalContainer}
      hideClose={false}
      hideModalFn={() => {
        clearSelections();
        return setIsOpen(false);
      }}
    >
      <H.Title3>Change your search</H.Title3>
      <div className={styles.searchDropdowns}>
        <SRPSearchBarDropdowns allowInteractiveSearch={false} />
      </div>
      <SearchButton
        className={styles.inlineButtonWrapper}
        size="large"
        disabled={disableModalSearchButton}
        onClick={() => {
          setIsOpen(false);
          navigateToSrp({
            selectedLocation,
            selectedTaxonomy: nextTaxonomySearch,
          });
        }}
      />
    </ModalContainer>
  );
};
